import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import '../../assets/styles/Contact.css';
import { connect } from 'react-redux';
import { listConstants } from '../../actions/ConstantsActions';
import { postMessage } from '../../actions/MessageActions';
import { validateEmail } from '../../utils/validators';
import { Input } from '../common';
import { HTML_PAGE } from '../../constants/globals';
import ContactShimmer from './Skeleton';
import { getCountriesListAPI } from '../../api/userAPI';
import { scrollToNavigation } from '../../utils/utils';

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            unfilled: false,
            emailError: false,
            name: '',
            email: '',
            subject: '',
            message: '',
            subscribe: true,
            attachment: {
                value: null,
                error: null,
            },
            country: { value: null, error: null },
            countries: [],
        };
    }

    componentDidMount() {
        scrollToNavigation();
        this.props.listConstants(HTML_PAGE.CONTACT_US);
        document.title = 'Contact » Askimam';

        getCountriesListAPI()
            .then((response) => {
                const countries = Object.entries(response.data)
                    .map(country => ({ value: country[0], label: country[1] }));

                this.setState({ countries });
            });
    }

    emailValidation = (event, error) => {
        if (!this.state.email) {
            return;
        }
        event.preventDefault();
        this.setState({ email: event.target.value, emailError: !!error });
    };

    handleChange = (data) => {
        data.preventDefault();
        const name = data.target.name;
        this.setState({ [name]: data.target.value });
    };

    handleCountryChange = (e) => {
        const prevState = this.state.country;

        this.setState({
            country: {
                ...prevState,
                label: e.target.label,
                value: e.target.value,
                error: null,
            },
        });
    };

    handleFileChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const prevState = this.state[name];
        const files = e.target.files;

        this.setState({
            [name]: {
                ...prevState,
                value: files[0],
            },
        });
    };

    handleSubmit = () => {
        const {
            name, email, subject, message, country, subscribe, attachment,
        } = this.state;

        if (!(name && email && subject && message)) {
            this.setState({ unfilled: true, submitted: false });
            return;
        }

        if (this.state.emailError) {
            this.setState({ unfilled: false, submitted: false });
            return;
        }

        const formData = new FormData();

        formData.append('full_name', name);
        formData.append('email', email);
        formData.append('country', country.value);
        formData.append('subject', subject);
        formData.append('message', message);
        formData.append('subscribe', subscribe);
        if (attachment.value) {
            formData.append('file', attachment.value, attachment.value.name);
        }
        this.props.postMessage(formData);

        document.getElementById('attachment').value = null;

        this.setState({
            name: '',
            email: '',
            country: '',
            subject: '',
            message: '',
            attachment: {
                value: null,
                error: null,
            },
            unfilled: false,
            submitted: true,
            emailError: false,
        });
    };

    renderContactInfo() {
        const contactInfo = this.props.constants.constants;
        return (
            <div dangerouslySetInnerHTML={{ __html: contactInfo[HTML_PAGE.CONTACT_US] }} />
        );
    }

    render() {
        const { countries, country } = this.state;
        const selectedCountry = country.value ? { label: country.label, value: country.value } : '';
        const countryStyles = country.error ? {
            control: styles => ({
                ...styles,
                borderColor: 'red !important',
            }),
        } : {};

        return (
            <div className="contact">
                <div className="heading">
                    <h2>Contact Us</h2>
                </div>
                <div className="rendered-content">
                    {
                        this.props.constants.isLoading ?
                            <ContactShimmer />
                            : this.renderContactInfo()
                    }
                </div>
                {
                    this.state.submitted
                    && <div className="flashMessage">Message submitted successfully.</div>
                }
                {
                    this.state.unfilled
                    && <div className="authMessage">Please fill all fields.</div>
                }
                {
                    this.state.emailError
                    && <div className="authMessage">Please enter a valid email address.</div>
                }
                <div className="contact-us-form">
                    <Input
                        name="name"
                        type="text"
                        label="Your Name (required)"
                        className="form-control"
                        id="MessageName"
                        maxLength={100}
                        handleChange={this.handleChange}
                        value={this.state.name}
                    />
                    <Input
                        name="email"
                        type="text"
                        label="Your Email (required)"
                        id="MessageEmail"
                        maxLength={100}
                        handleChange={this.handleChange}
                        value={this.state.email}
                        onBlur={e => this.emailValidation(e, validateEmail(this.state.email))}
                    />
                    <div className="select-option-holder">
                        <div className="form-group input-field custom-select">
                            <div className="country-select">
                                <Select
                                    options={countries}
                                    placeholder="Please choose country..."
                                    onChange={(value, { action }) => {
                                        if (action === 'select-option') {
                                            const e = {
                                                target: {
                                                    value: value.value,
                                                    label: value.label,
                                                    name: 'country',
                                                },
                                                preventDefault: () => {
                                                },
                                            };
                                            this.handleCountryChange(e);
                                        }
                                    }}
                                    value={selectedCountry}
                                    styles={countryStyles}
                                />
                            </div>
                        </div>
                        <div style={{ flex: 3.4 }} />
                    </div>
                    <Input
                        name="subject"
                        type="text"
                        label="Subject"
                        id="MessageTitle"
                        maxLength={255}
                        handleChange={this.handleChange}
                        value={this.state.subject}
                    />
                    <Input
                        label="Your Message (required)"
                        name="message"
                        cols={30}
                        rows={10}
                        handleChange={this.handleChange}
                        value={this.state.message}
                    />
                    <div className="file-holder">
                        <input
                            type="file"
                            id="attachment"
                            name="attachment"
                            className="file-to-upload"
                            onChange={this.handleFileChange}
                        />
                    </div>
                    <div className="newsletter-holder">
                        <label>Subscribe to Newsletter and Updates</label>
                        <select
                            name="subscribe"
                            className="newsletter"
                            value={this.state.subscribe}
                            onChange={this.handleChange}
                        >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <button type="submit" className="submit button danger-button" onClick={this.handleSubmit}>
                        Send
                    </button>
                </div>
            </div>
        );
    }
}

Contact.propTypes = {
    constants: PropTypes.object.isRequired,
    listConstants: PropTypes.func.isRequired,
    postMessage: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listConstantsReducer, postMessageReducer }) => ({
    constants: listConstantsReducer,
    postedMessage: postMessageReducer,
});

export default connect(mapStateToProps, { listConstants, postMessage })(Contact);
